export const getTextWidth = (text, styles = {}) => {
  let span = document.createElement('span');
  for (let style in styles) {
    span.style[style] = styles[style];
  }

  span.style.position = 'absolute';
  span.style.visibility = 'hidden';

  span.textContent = text;
  document.body.appendChild(span);
  let width = span.getBoundingClientRect().width;
  document.body.removeChild(span);

  return width;
};
